"use strict";
/**
 * Module-level configuration for the AI Hub Library.
 *
 * Host applications must call `configureAiHubLibrary()` once at startup
 * to inject platform-specific dependencies (HTTP helpers, socket client).
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSocketClient = exports.getApiDelete = exports.getApiPatchNative = exports.getApiPatch = exports.getApiPut = exports.getApiPost = exports.getApiGet = exports.configureAiHubLibrary = void 0;
// ── Internal state ──────────────────────────────────────────────
var _config = null;
// ── Public API ──────────────────────────────────────────────────
/**
 * Initialise the library with host-specific dependencies.
 * Must be called **once** before any service or hook is used.
 */
exports.configureAiHubLibrary = function (config) {
    _config = config;
};
/** Return the configured `apiGet` function. Throws if not configured. */
exports.getApiGet = function () {
    if (!_config) {
        throw new Error('AI Hub Library not configured. Call configureAiHubLibrary() first.');
    }
    return _config.apiGet;
};
/** Return the configured `apiPost` function. Throws if not configured. */
exports.getApiPost = function () {
    if (!_config) {
        throw new Error('AI Hub Library not configured. Call configureAiHubLibrary() first.');
    }
    return _config.apiPost;
};
/** Return the configured `apiPut` function. Throws if not configured. */
exports.getApiPut = function () {
    if (!_config) {
        throw new Error('AI Hub Library not configured. Call configureAiHubLibrary() first.');
    }
    return _config.apiPut;
};
/**
 * Return the configured `apiPatch` function. Falls back to `apiPost`
 * with an `X-HTTP-Method-Override: PATCH` header if the host did not
 * supply a dedicated PATCH helper.
 */
exports.getApiPatch = function () {
    if (!_config) {
        throw new Error('AI Hub Library not configured. Call configureAiHubLibrary() first.');
    }
    if (_config.apiPatch) {
        return _config.apiPatch;
    }
    var post = _config.apiPost;
    return function (url, data, headers) {
        return post(url, data, __assign(__assign({}, (headers || {})), { 'X-HTTP-Method-Override': 'PATCH' }));
    };
};
/**
 * Return only a native PATCH helper from host configuration.
 * Throws when host did not supply `apiPatch`, so callers can enforce
 * a real HTTP PATCH instead of POST method-override fallback.
 */
exports.getApiPatchNative = function () {
    if (!_config) {
        throw new Error('AI Hub Library not configured. Call configureAiHubLibrary() first.');
    }
    if (!_config.apiPatch) {
        throw new Error('Native apiPatch not configured. Provide apiPatch in configureAiHubLibrary().');
    }
    return _config.apiPatch;
};
/**
 * Return the configured `apiDelete` function. Falls back to `apiPost`
 * with an `X-HTTP-Method-Override: DELETE` header if the host did not
 * supply a dedicated DELETE helper.
 */
exports.getApiDelete = function () {
    if (!_config) {
        throw new Error('AI Hub Library not configured. Call configureAiHubLibrary() first.');
    }
    if (_config.apiDelete) {
        return _config.apiDelete;
    }
    var post = _config.apiPost;
    return function (url, data, headers) {
        return post(url, data || {}, __assign(__assign({}, (headers || {})), { 'X-HTTP-Method-Override': 'DELETE' }));
    };
};
/** Return the configured socket client. Throws if not configured. */
exports.getSocketClient = function () {
    if (!_config) {
        throw new Error('AI Hub Library not configured. Call configureAiHubLibrary() first.');
    }
    return _config.socketClient;
};
